import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";

import { Translate, setLocale } from "react-redux-i18n";
import {
  formatLanguageCode,
  fetchAllowedLanguagesOnly,
  languageExists,
  fetchTranslationV2,
} from "../../actions/languageActions";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";

import loginBg from "../../styles/images/loginBg.png";
import loginBgGoCharge from "../../styles/images/fundoGoCharge.png";
import loginBgHyundai from "../../styles/images/fundoHyundai.jpg";
import evio_o from "../../styles/images/evio_o.svg";
import "../../styles/components/static/Home.scss";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    fetchAllowedLanguagesOnly();
  }

  changeLanguage = (lang) => {
    if (languageExists()) {
      this.props.fetchTranslationV2(lang);
    }
    axios.defaults.headers.common["language"] = lang;
  };

  buildLanguageDropdown() {
    /* builds the language selector with the allowed languages loaded in fetchAllowedLanguagesOnly */
    const { locale, languages } = this.props;

    return (
      <DropdownButton title={formatLanguageCode(locale)}>
        {languages.map((langCode) => (
          <Dropdown.Item
            key={langCode}
            onClick={() => this.changeLanguage(langCode)}
          >
            {formatLanguageCode(langCode)}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    );
  }

  render() {
    return (
      <div id="home">
        <div className="bg-right">
          <img
            src={
              this.props.brand?.brandName === "Salvador Caetano"
                ? loginBgGoCharge
                : this.props.brand?.brandName === "Hyundai"
                ? loginBgHyundai
                : loginBg
            }
            className="background"
            alt=""
          />
          <div className="welcome-container">
            <div className="welcome">
              <Translate value="login_image_welcome1" />
              {this.props.brand?.brandName !== "EVIO" ? (
                <span>o</span>
              ) : (
                <img src={evio_o} alt="" />
              )}

              <Translate value="login_image_welcome2" />
            </div>
            <p>
              <Translate
                value={`login_welcome_${this.props.brand?.brandTitle}`}
              />
            </p>
          </div>
        </div>
        <div className="lang-picker">{this.buildLanguageDropdown()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  languages: state.language.languages,
});

export default connect(mapStateToProps, {
  setLocale,
  formatLanguageCode,
  fetchAllowedLanguagesOnly,
  languageExists,
  fetchTranslationV2,
})(Home);
